module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/1@2x_2041da25bd522a9c90f54396e0fa3cad.png";